<template>
    <Header></Header>

    <div class="container">
        <section class="login_wrap login_bg">
            <div class="login sign_form">
                <h3>로그인</h3>
                <ul>
                    <li>
                        <input type="text" v-model="state.username" v-on:keyup.enter="login" placeholder="아이디" />
                    </li>
                    <li>
                        <input type="password" v-model="state.password" v-on:keyup.enter="login" placeholder="비밀번호" />
                    </li>
                </ul>
                <div class="link_wrap">
                    <button type="button" class="" @click="openModal(0, false)">아이디 찾기</button>
                    <span class="deco">｜</span>
                    <button type="button" class="" @click="openModal(1, false)">비밀번호 찾기</button>
                    <router-link to="/join" class="main_c">회원가입</router-link>
                </div>
                <div class="btn_wrap _default">
                    <button type="button" class="submit_btn" @click="login">로그인</button>
                </div>
                <div class="sns_wrap">
                    <p>SNS 계정으로 간편하게 가입하기</p>
                    <div class="sns_btn_wrap _default">
                        <!-- <button type="button" class="" @click="snsLogin('kakao')"><img src="img/kakao.png" alt="" /></button> -->
                        <button type="button" class="" @click="snsLogin('naver')"><img src="img/naver.png" alt="" /></button>
                    </div>
                </div>
            </div>
        </section>
    </div>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :isForm="!state.modalIsResult"
        :isResult="state.modalIsResult"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>

    <ModalDefault
        v-if="state2.isShowModal"
        :type="state2.modalTab"
        :title="state2.modalTitle"
        :content="state2.modalContent"
        @close="closeModal2"
        @callback="callBackModal2"
    ></ModalDefault>

    <Footer></Footer>
</template>

<script lang="ts" config>
    import {
        useI18n,
        userStore,
        apiService,
        reactive,
        router,
        onMounted,
        ModalComponent,
        ModalDefault,
        globalStore,
        watch,
        Header,
        Footer,
        types,
        useRoute,
        getMessageByCode,
        CommonUtils,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: { ModalComponent, Header, Footer, ModalDefault },
        setup() {
            const user = userStore();
            const global = globalStore();
            const route = useRoute();
            const state = reactive({
                placeholdID: "",
                placeholdPW: "",
                username: "",
                password: "",
                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,
                modalYes: "확인" as string,

                redirectUrl: "" as any,
            });

            const state2 = reactive({
                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,
                modalYes: "확인" as string,
            });

            onMounted(() => {
                user.$reset();

                if (route.query.redirect) {
                    state.redirectUrl = route.query.redirect;
                }
            });
            const t = useI18n();
            const login = async () => {
                const param: types.ReqLogin = {
                    id: state.username,
                    pw: state.password,
                };
                let res: types.ResCommon = await apiService.auth.login(param);
                if (res.returnCode === 0) {
                    let res2: types.ResUserInfo = await apiService.mypage.me();
                    if (res2.returnCode === 0) {
                        user.setInfo({
                            id: res2.data.memberVO.id,
                            idx: res2.data.memberVO.idx,
                            name: res2.data.memberVO.name,
                            isAdmin: res2.data.memberVO.gubun !== 3,
                            gubun: res2.data.memberVO.gubun,
                            snsGubun: res2.data.gubun !== 1,
                            hasAuth: res2.data.memberVO.hasAuth,
                        });
                        user.setRole(res2.data.roleVO);
                        if (state.redirectUrl) router.replace(state.redirectUrl);
                        else router.replace("/");
                    } else if (res2.returnCode === 11) {
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res2.returnCode);
                        state.isShowModal = true;
                    }
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const snsLogin = async (snsType: string) => {
                const url = process.env.VUE_APP_SNS_LOGIN_URI + `/auth/${snsType}/login`;

                const loginWindow = window.open(url, "_blank");

                window.removeEventListener("message", receiveMessage);
                window.addEventListener("message", (event) => receiveMessage(event), { once: true });
            };

            const receiveMessage = async (event: any) => {
                if (!event.origin || !event.origin.includes(process.env.VUE_APP_BACK_DOMAIN)) return;

                const { accessToken, refreshToken } = event.data;

                if (accessToken && refreshToken) {
                    await user.setAccessToken(accessToken);
                    await user.setRefreshToken(refreshToken);

                    let res2: types.ResUserInfo = await apiService.mypage.me();
                    if (res2.returnCode === 0) {
                        user.setInfo({
                            id: res2.data.memberVO.id,
                            idx: res2.data.memberVO.idx,
                            name: res2.data.memberVO.name,
                            isAdmin: res2.data.memberVO.gubun !== 3,
                            gubun: res2.data.memberVO.gubun,
                            snsGubun: res2.data.gubun !== 1,
                            hasAuth: res2.data.memberVO.hasAuth,
                        });
                        user.setRole(res2.data.roleVO);
                        if (state.redirectUrl) router.replace(state.redirectUrl);
                        else router.replace("/");
                    } else if (res2.returnCode === 11) {
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res2.returnCode);
                        state.isShowModal = true;
                    }
                } else {
                    global.setSnsInfo(event.data);
                    router.push("/join");
                }

                window.removeEventListener("message", receiveMessage);
            };

            const closeModal = () => {
                state.isShowModal = false;
                state.modalTab = -1;
            };

            const openModal = (tab: number, isResult: boolean) => {
                state.modalTab = tab;
                state.isShowModal = true;
                state.modalIsResult = isResult;
            };

            const callBackModal = async (param: any) => {
                if (param.action === "findId") {
                    const parameter: types.ReqFindId = {
                        name: param.name,
                        phone: param.phone,
                    };
                    const res: types.ResFindUserInfo = await apiService.base.findId(parameter);
                    if (res.returnCode === 0 && res) {
                        state.modalContent = res.id;
                        state.modalIsResult = true;
                    } else if (res.returnCode === 11) {
                    } else {
                        state2.modalTab = -1;
                        state2.modalTitle = "예외 발생";
                        state2.modalContent = getMessageByCode(res.returnCode);
                        state2.isShowModal = true;
                    }
                } else if (param.action === "findPw") {
                    const parameter: types.ReqFindPw = {
                        id: param.id,
                        name: param.name,
                        phone: param.phone,
                    };
                    const res: types.BaseResponse = await apiService.base.findPw(parameter);
                    if (res.returnCode === 0) {
                        state.modalTab = 1;
                        state.modalIsResult = true;
                    } else if (res.returnCode === 11) {
                    } else {
                        state2.modalTab = -1;
                        state2.modalTitle = "예외 발생";
                        state2.modalContent = getMessageByCode(res.returnCode);
                        state2.isShowModal = true;
                    }
                } else if (param.action === "changePw") {
                    const parameter: types.ReqChangePw = {
                        id: param.id,
                        oldPw: param.oldPw,
                        newPw: param.newPw,
                        newPwRe: param.newPw2,
                    };
                    const res: types.BaseResponse = await apiService.base.updatePw(parameter);
                    if (res.returnCode === 0) {
                        state.isShowModal = false;
                        state.modalIsResult = true;

                        state2.modalTab = -1;
                        state2.modalTitle = "변경 완료";
                        state2.modalContent = getMessageByCode(res.returnCode);
                        state2.isShowModal = true;
                    } else if (res.returnCode === 11) {
                    } else {
                        console.error(res.description);

                        state2.modalTab = -1;
                        state2.modalTitle = "예외 발생";
                        state2.modalContent = getMessageByCode(res.returnCode);
                        state2.isShowModal = true;
                    }
                }
            };

            const closeModal2 = () => {
                state2.isShowModal = false;
                state2.modalTab = -1;
            };

            const callBackModal2 = async (param: any) => {};

            return {
                state,
                state2,
                login,
                router,
                closeModal,
                // changeLang,
                snsLogin,
                openModal,
                callBackModal,

                closeModal2,
                callBackModal2,
            };
        },
    };
</script>

<style scoped></style>
